import { useState } from 'react';
import DashboardLayout from '@/components/feature/DashboardLayout';
import Tabs from '@/components/base/Tabs';
import RevenueTab from '@/pages/finance/components/RevenueTab';
import CommissionsTab from '@/pages/finance/components/CommissionsTab';
import SettlementsTab from '@/pages/finance/components/SettlementsTab';

const TABS = [
  { id: 'revenue', label: 'ملخص الإيرادات' },
  { id: 'commissions', label: 'تفصيل العمولات' },
  { id: 'settlements', label: 'التسويات' },
];

export default function FinancePage() {
  const [activeTab, setActiveTab] = useState('revenue');

  return (
    <DashboardLayout title="المعاملات المالية">
      <div className="space-y-6">
        <h2 className="font-bold text-[18px] text-foreground-950">المعاملات المالية</h2>

        <div className="rounded-card border border-background-200 bg-white shadow-card">
          <div className="px-2 pt-1">
            <Tabs tabs={TABS} active={activeTab} onChange={setActiveTab} />
          </div>
          <div className="p-5">
            {activeTab === 'revenue' && <RevenueTab />}
            {activeTab === 'commissions' && <CommissionsTab />}
            {activeTab === 'settlements' && <SettlementsTab />}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}